/** Font-independent controls for the public site and account surfaces. */
export default function PublicIcon({ name, className = "", lean }) {
  const paths = {
    "arrow-up-right": "M5 19 19 5M5 5h14v14",
    "arrow-right": "M4 12h16m-6-6 6 6-6 6",
    "arrow-left": "M20 12H4m6-6-6 6 6 6",
    copy: "M9 9h10v11H9ZM5 15V4h10",
    lock: "M6 11h12v9H6ZM8.5 11V8a3.5 3.5 0 0 1 7 0v3",
    "link-off":
      "M9.5 14.5 7 17a3.5 3.5 0 0 1-5-5l2.5-2.5M14.5 9.5 17 7a3.5 3.5 0 0 1 5 5l-2.5 2.5M8 3v3M3 8h3M16 21v-3M21 16h-3",
    "arrow-down": "M12 4v16m-6-6 6 6 6-6",
    menu: "M4 6h16M4 12h16M4 18h16",
    close: "m6 6 12 12M6 18 18 6",
    plus: "M12 5v14M5 12h14",
    play: "m8 5 11 7-11 7Z",
    pause: "M8 5v14M16 5v14",
    alert:
      "M12 8v5m0 3h.01M10.3 4.8 2.5 18.3A1.8 1.8 0 0 0 4.1 21h15.8a1.8 1.8 0 0 0 1.6-2.7L13.7 4.8a2 2 0 0 0-3.4 0Z",
    check: "m5 12 4 4L19 6",
    eye: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Zm10-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
    "eye-off":
      "m3 3 18 18M10.6 5.1 12 5c6.5 0 10 7 10 7a20 20 0 0 1-3 3.7M6.1 6.1A20 20 0 0 0 2 12s3.5 7 10 7a11 11 0 0 0 5-1.2M9.9 9.9a3 3 0 0 0 4.2 4.2",
    phone:
      "M5 4h3.2l1.6 4-2 1.3a11 11 0 0 0 4.9 4.9l1.3-2 4 1.6V17a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2Z",
    "phone-end":
      "M2.6 15.1c-.4-.4-.5-1-.2-1.4C4.7 10.6 8.2 9 12 9s7.3 1.6 9.6 4.7c.3.4.2 1-.2 1.4l-1.9 1.9c-.4.4-1 .4-1.4.1l-2.1-1.6a1.2 1.2 0 0 1-.5-1v-2a10.5 10.5 0 0 0-7 0v2c0 .4-.2.8-.5 1l-2.1 1.6c-.4.3-1 .3-1.4-.1Z",
    "mic-off":
      "m3 3 18 18M9 9v2a3 3 0 0 0 5 2.2M15 9.5V5a3 3 0 0 0-5.7-1.3M5 11a7 7 0 0 0 11.3 5.5M19 11a7 7 0 0 1-.6 2.8M12 18v3",
    hold: "M9 5v14M15 5v14",
    transfer: "M4 8h13m-4-4 4 4-4 4M20 16H7m4-4-4 4 4 4",
    keypad:
      "M5 4.5h2v2H5zM11 4.5h2v2h-2zM17 4.5h2v2h-2zM5 10h2v2H5zM11 10h2v2h-2zM17 10h2v2h-2zM5 15.5h2v2H5zM11 15.5h2v2h-2zM17 15.5h2v2h-2zM11 20h2v1.5h-2z",
    headset:
      "M4 15v-3a8 8 0 0 1 16 0v3M4 15a2 2 0 0 0 2 2h1v-5H6a2 2 0 0 0-2 2Zm16 0a2 2 0 0 1-2 2h-1v-5h1a2 2 0 0 1 2 2Zm-3 2c0 2-2 3-5 3",
    whisper: "M4 5h16v10H9l-5 4Z",
    join: "M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM8 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5 7a5 5 0 0 1 10 0m1-1a5 5 0 0 1 7-4.6",
    clock: "M12 7v5l3 2M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
    calendar: "M4 6h16v14H4ZM4 10h16M8 3v4M16 3v4",
    flag: "M5 21V4m0 0h11l-2 4 2 4H5",
  };
  return (
    <svg
      className={"nx-public-icon " + className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      data-lean={lean}
    >
      <path d={paths[name] || paths["arrow-right"]} />
    </svg>
  );
}
